export const ACCEPTED_LOGO_FORMATS = { 'image/png': ['.png'], 'image/jpeg': ['.jpg', '.jpeg'] } as const;

export function removeDuplicates(arr: string[]) {
    return arr.filter((item, i) => {
        return !arr.slice(i + 1).includes(item);
    });
}

export const getParameterWithDefault = <T, K extends keyof T, Defaults>(
    skillSettings: T,
    defaults: Defaults,
    parameter: K & keyof Defaults,
) => {
    return typeof skillSettings[parameter] !== 'undefined' ? skillSettings[parameter] : defaults[parameter];
};

export const hasSpecialChars = (text: string) => /[$&+~,:;=?@#|/'"`<>.\\^*()%! ]/.test(text);
